import { IBaoCaoTheoThangFilter } from '../pages/bao-cao-diem-danh-layout/theo-thang/TheoThangPage';
import { IBaoCaoDiemNenNepFilter } from '../pages/bao-cao-diem-nen-nep/BaoCaoDiemNenNepPage';
import { apiClient } from './apiClient';


export const baoCaoDiemNenNepApi = {
    SelectTheoThangAsync: (request:IBaoCaoDiemNenNepFilter) => apiClient.post(`bao-cao/diem-nen-nep/theo-thang`, request),
}